import React, { useContext } from 'react';
import { Card, Button, Badge } from 'react-bootstrap';
import { CartContext } from '../../context/CartContext';
import { LanguageContext } from '../../context/LanguageContext';
import { NotificationContext } from '../../context/Notification';

export default function ProductCard({ product }) {
  const { addToCart } = useContext(CartContext);
  const { language } = useContext(LanguageContext);
  const { showNotification } = useContext(NotificationContext);

  const handleAddToCart = () => {
    

  }
  
        
  return (
    <>
   <div className='card'>
    <Card className="product-card border-0 shadow-lg rounded-4 w-100 h-100">
      <div className="position-relative">
        <Card.Img
          variant="top"
          src={product.image }
          alt={product.name[language]}
          style={{ height: '200px', objectFit: 'cover', borderTopLeftRadius: '1rem', borderTopRightRadius: '1rem' }}
        />
        <Badge
          bg={product.stock > 0 ? 'success' : 'danger'}
          className="position-absolute top-0 end-0 m-2 px-3 py-2 fs-6 rounded-pill shadow"
        >
          {product.stock > 0
            ? (language === 'tr' ? 'Stokta' : 'In Stock')
            : (language === 'tr' ? 'Tükendi' : 'Out of Stock')}
        </Badge>
      </div>
      <Card.Body className="d-flex flex-column p-4">
        <Card.Title className="fw-bold fs-5 mb-2 text-primary">
          {product.name[language]}
        </Card.Title>
        <Card.Text className="text-muted small mb-3" style={{ minHeight: 40 }}>
          {product.description[language]}
        </Card.Text>
        <div className="d-flex align-items-center mb-3">
          <span className="h5 mb-0 text-success me-2">
            ${product.price.toFixed(2)}
          </span>
          <span className="text-secondary small">{product.currency}</span>
        </div>
      </Card.Body>
    </Card>
    </div>
     </>
  );
}
